module.exports = __webpack_public_path__ + "img/49f8711.png";